/**
 * Was das angemeldete Konto hat — die Lage für die Oberfläche. (19.10.2026)
 *
 * app.ts setzt sie beim Anmelden (aus /api/auth/me); Einstellungen, Anruf-Knopf und alles andere fragen
 * `kontoGruppen()`. Die Regeln stehen in shared/einstellungen-sichtbar.ts — hier nur der Halter.
 *
 * Die Kennung kommt wie bisher aus `window.__voiceV8Uid` (app.ts setzt sie beim Anmelden; ein Besitzer, kein zweiter Stand).
 * ⚠️ Vorgabe ohne Wissen: kein Konto, kein Anruf — es erscheint zu wenig, nie zu viel.
 */
import { HAUPTKONTO, verfuegbarFuerKonto, type EinstGruppe, type KontoLage } from "../../shared/einstellungen-sichtbar.js";

let anrufImPaket = false;

/** Das Paket des Kontos sagt, ob es den Anruf gibt (`features.call`). */
export function setzeAnrufImPaket(an: boolean): void {
  anrufImPaket = an === true;
}

/** Die zuletzt angemeldete Kennung (app.ts CURRENT_UID_KEY) — Rückfall, wenn der Start ohne Server lief und `__voiceV8Uid` fehlt. */
const LETZTE_KENNUNG = "voice-v8.current-uid";

/** Die Kennung des angemeldeten Kontos — vor der Anmeldung die zuletzt angemeldete; `null`: nicht bekannt. */
export function kontoKennung(): number | null {
  return kontoUid();
}

export function kontoUid(): number | null {
  try {
    const uid = (window as unknown as { __voiceV8Uid?: number }).__voiceV8Uid;
    if (typeof uid === "number") return uid;
  } catch {
    /* ohne Fenster */
  }
  try {
    const n = Number(localStorage.getItem(LETZTE_KENNUNG));
    return Number.isInteger(n) && n > 0 ? n : null;
  } catch {
    return null;
  }
}

/** Konto 1 behält den Anruf auch, wenn eine alte Antwort `features` nicht kennt (der Anruf-Knopf stand bisher an der Kennung). */
export function kontoLage(): KontoLage {
  const uid = kontoUid();
  return { uid, anruf: anrufImPaket || uid === HAUPTKONTO };
}

export function kontoGruppen(): Record<EinstGruppe, boolean> {
  return verfuegbarFuerKonto(kontoLage());
}
